<template>
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
       viewBox="0 0 512 512" xml:space="preserve" fill="currentColor">
<g>
	<g>
		<path d="M256,218.994c-42.767,0-77.56,34.793-77.56,77.56s34.794,77.56,77.56,77.56c42.768,0,77.56-34.793,77.56-77.56
			S298.768,218.994,256,218.994z M256,358.907c-34.381,0-62.352-27.971-62.352-62.352c0-34.381,27.971-62.352,62.352-62.352
			c34.381,0,62.352,27.971,62.352,62.352C318.352,330.936,290.381,358.907,256,358.907z"/>
	</g>
</g>
    <g>
	<g>
		<path
        d="M445.695,96.317V40.554h-30.166V0H96.472v40.554H66.306v55.762h30.551l4.208,81.161H90.912l12.348,238.154h10.153 L118.408,512h275.184l4.996-96.369h10.153l12.349-238.154h-10.154l4.208-81.161H445.695z M394.301,400.424H178.947h-0.001v15.208 h0.001H383.36l-4.208,81.161H132.847l-4.208-81.161h30.026v-15.208h-40.967l-10.77-207.738h298.142L394.301,400.424z M112.084,96.317h287.831l-4.208,81.161H116.292L112.084,96.317z M96.067,81.109H81.513V55.762h14.959h62.195V40.554H111.68 V15.208h288.639v25.346H178.947v15.208h236.581h14.959v25.346h-14.554H96.067z"/>
	</g>
</g>
</svg>

</template>

<script>
export default {
  name: "CoffeeIcon"
}
</script>

<style scoped>

</style>